module.exports = __webpack_public_path__ + "static/media/CTLA_11-135w.588f2086.jpg";